import {createInfiniteHitsSessionStorageCache} from "instantsearch.js/es/lib/infiniteHitsCache";
export default createInfiniteHitsSessionStorageCache();
